import { useAxios } from "./useAxios"
import { useOrganization } from "./useOrganization"

const apiRestAxios = useAxios(process.env.VUE_APP_API_REST_BASE_URL)

export function useVariant() {
  const { organization } = useOrganization()

  async function getAllByProductId(productId: number) {
    const response = await apiRestAxios.get(`/organizations/${organization.id}/products/${productId}/variants`)

    return response.data
  }

  return {
    getAllByProductId
  }
}